import React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

// Styled iOS Switch component
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#0060FF',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

// HOC for making the Switch reusable
const withSwitch = (Component) => ({ checked, onChange, label, ...props }:any) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <Component checked={checked} onChange={onChange} {...props} />
    {label && <span className='p-2' style={{borderRadius:"14px", marginLeft: 8 , color: checked ? '#3F7ADD' : '#000',backgroundColor: checked ? '#EFF8FF' : '#F5F8FA',}} >{label}</span>}
  </div>
);

const IosSwitchBtn = withSwitch(IOSSwitch);

export default IosSwitchBtn;
